module.exports = __webpack_public_path__ + "img/bangzhu1.e36684e9.png";